import type { ConversationItemIconsProps } from './index.types';
import { Icon } from 'Components/shared/Icon';
import { MobXProviderContext, observer } from 'mobx-react';
import { useConversationStore } from 'Modules/conversation/store/index.store';
import * as React from 'react';
import { RootStoreProps } from 'Stores/RootStore.types';
import { cn } from '~/lib/utils';

const ConversationItemIcons: React.FC<ConversationItemIconsProps> = ({
  conversation,
  className,
}) => {
  const {
    ui: { selectIfConvMuted },
  } = React.useContext<RootStoreProps>(MobXProviderContext);

  const { getIsConversationPinned } = useConversationStore();

  return (
    <div className={cn('flex gap-[5px]', className)}>
      {selectIfConvMuted(conversation?.id) && <Icon icon="muted" />}
      {getIsConversationPinned(conversation?.id) && (
        <Icon icon="pin" testId="conversation-pin" />
      )}
    </div>
  );
};

export default observer(ConversationItemIcons);
